interface TabSelectorProps<T extends string> {
  tabs: { id: T; label: string }[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  className?: string;
}

export const TabSelector = <T extends string>({
  tabs,
  activeTab,
  onTabChange,
  className = ''
}: TabSelectorProps<T>) => {
  return (
    <div className={`flex border-b border-gray-200 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`
            px-4 py-2 text-sm font-medium border-b-2 -mb-px
            transition-colors relative
            ${activeTab === tab.id
              ? 'border-blue-500 text-blue-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }
          `}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
